import React, { useEffect, useState, useRef, useCallback, ReactElement } from "react";
import WidgetCard from "./WidgetCard";
import { buildWidgetCardFilters } from "@/ts/revstack/ui-utils";
import { RevstackFilterTypes, WidgetType } from "@ts/common-types";
import { w5WidgetFormatter } from "@/ts/revstack/formatters";
import { renderWidgetStructure } from "@/ts/revstack/renderers";

interface IRevstackSovVolumeWidgetProps {
    widgetConfig: any;
    widgetData: any;
    widgets: any;
    title: string;
    isTitleRequired?: boolean;
    isCardRequired?: boolean;
    icon?: ReactElement;
}

const RevstackSovPieWidget: React.FC<
    IRevstackSovVolumeWidgetProps
> = ({
    widgetConfig,
    widgetData,
    widgets,
    title,
    isTitleRequired = true,
    isCardRequired = true,
    icon
}) => {
        const chartContainerRef = useRef<HTMLDivElement>(null);
        const chartComponentRef = useRef<any>(null);
        //TODO: @sarvesh this have to be made generic...
        const [categories, setCategories] = useState([])
        const [category, setCategory] = useState("all");


        // Memoized setter for category to be passed to child components
        const handleSetCategories = useCallback((value: string[]) => {
            setCategories(value);
        }, []);

        useEffect(() => {
            if (!chartContainerRef.current || !chartComponentRef.current) return;
            const observer = new window.ResizeObserver(() => {
                if (chartComponentRef.current && chartComponentRef.current.chart) {
                    chartComponentRef.current.chart.reflow();
                }
            });
            observer.observe(chartContainerRef.current);
            return () => observer.disconnect();
        }, []);

        return (
            <WidgetCard
                overwriteDefaultClass={!isCardRequired}
                className={
                    !isCardRequired
                        ? "bg-transparent border-0 rounded-0 shadow-none"
                        : ""
                }
                style={{ height: "350px" }}
            >
                {isTitleRequired && (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <div className="d-flex gap-1 align-items-center">
                                <span
                                    className="icon-btn"
                                    style={{
                                        marginRight: 10,
                                    }}
                                >
                                    {icon}
                                </span>
                                <div className="d-flex flex-column justify-content-start">
                                    <h4 className="mb-0">
                                        {title || "Category Performance"}
                                    </h4>
                                </div>
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                                {
                                    widgetConfig?.config?.isTrendsButtonRequired ? 
                                buildWidgetCardFilters({
                                    filters: [
                                        {
                                            type: RevstackFilterTypes.TRENDS,
                                            section: "",
                                            disabled: true,
                                            isComingSoon: true
                                        }
                                    ]
                                })
                                : ""}
                                {
                                    categories.length > 0 ? buildWidgetCardFilters({
                                        filters: [
                                            {
                                                type: RevstackFilterTypes.SELECT,
                                                section: "", //TODO
                                                props: {
                                                    options: categories.length ? categories : [],
                                                    value: category ? category : "all",
                                                    onChange: setCategory,
                                                    width: 140
                                                },
                                            },
                                        ]
                                    }) : ""
                                }

                            </div>


                        </div>

                    </div>

                )}
                <div ref={chartContainerRef} className="w-100 h-100">
                    {renderWidgetStructure(widgets, (widgetList: any, widgetIdx: number) => {
                        const shouldShowWidget = widgetList.type === WidgetType.W5;

                        if (!shouldShowWidget) return null;

                        const currentChartData = w5WidgetFormatter(widgetList, widgetData);

                        if (!widgetList.widgetComponent) {
                            console.warn(
                                `Widget component not found for type: ${widgetList.type}`
                            );
                            return null;
                        }

                        const WidgetComponent = widgetList.widgetComponent;

                        return (
                            <WidgetComponent
                                key={`${widgetList.type}-${widgetIdx}`}
                                chartComponentRef={chartComponentRef}
                                widgetData={currentChartData?.chartDataSeries}
                                myBrands={currentChartData?.myBrands}
                                graphAttributes={{
                                    yAxisTitle: currentChartData?.yAxisTitle,
                                    hideXAxisTitle: true,
                                }}
                                yAxisUnit={currentChartData?.yAxisUnit}
                                graphColors={currentChartData?.graphColors}
                                isLoading={currentChartData?.isLoading}
                                config={widgetList.config}
                            />
                        );
                    })}
                </div>
            </WidgetCard>
        );
    };

export default RevstackSovPieWidget;
